export const questions = {
  "gameType": "Bonus6m",
}